import {
    MenuQuery as SourceMenuQuery
} from 'SourceQuery/Menu.query';
import { Field } from 'Util/Query';

/** @namespace PeggysagePwa/Query/Menu/Query */
export class MenuQuery extends SourceMenuQuery {
    /**
     * Override
     * @returns {string[]}
     * @private
     */
    _getMenuItemFields() {
        return [
            ...super._getMenuItemFields(),
            'is_promo',
            'promo_image',
            'additional_menu',
            new Field('related_pages').addFieldList([
                'title',
                'url',
                'page_type',
                'content_image_thumb',
                'page_link_type_title'
            ]),
            'is_new_products',
            new Field('content_push').addFieldList([
                'supertitle',
                'title',
                'page_identifier',
                'image_url',
                'position'
            ])
        ];
    }
}

export default new MenuQuery();
